import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zAttrFormula = z.object({
  editor: z.literal("Formula"),
  formula: z.string(),
  // Сохраняемые зависимости, включая атрибуты-ссылки на другие объекты.
  // Карточка определяет актуальные зависимости по formula для поддержки старых данных.
  argumentAtts: zUid.array().optional(),
  precision: z.number().nullable().optional(),
  addonBefore: z.string().nullable().optional(),
  addonAfter: z.string().nullable().optional(),
});
export type ZAttrFormula = z.infer<typeof zAttrFormula>;
export const makeFormulaProps = (src: ZAttrFormula) => ({
  precision: src.precision ?? undefined,
  addonBefore: src.addonBefore ?? undefined,
  addonAfter: src.addonAfter ?? undefined,
});
